import type { CSSProperties, ReactNode, JSX} from "react";
import { Icon } from "./Icon";
import type { IconName } from "./Icon";

export interface PanelShellProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function PanelShell({ children, className }: PanelShellProps): JSX.Element {
  return <div className={`flex h-full flex-col ${className ?? ""}`}>{children}</div>;
}

export interface PanelHeaderProps {
  readonly title: ReactNode;
  readonly action?: ReactNode;
  readonly className?: string;
  readonly titleClassName?: string;
}

export function PanelHeader({
  title,
  action,
  className,
  titleClassName,
}: PanelHeaderProps): JSX.Element {
  return (
    <header
      className={`shrink-0 flex items-center justify-between ${className ?? "h-[52px] px-6"}`}
    >
      <div className="min-w-0">
        <div
          className={`truncate ${titleClassName ?? "text-[15px] font-semibold leading-tight text-content"}`}
        >
          {title}
        </div>
      </div>
      {action ?? null}
    </header>
  );
}

export interface IconRoundBadgeProps {
  readonly iconName: IconName;
  readonly colorClassName: string;
  readonly iconSize?: number;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function IconRoundBadge({
  iconName,
  colorClassName,
  iconSize = 14,
  className,
  style,
}: IconRoundBadgeProps): JSX.Element {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full text-white ${colorClassName} ${className ?? ""}`}
      style={style}
    >
      <Icon name={iconName} size={iconSize} />
    </span>
  );
}

export interface IconActionButtonProps {
  readonly iconName: IconName;
  readonly iconSize?: number;
  readonly onClick?: () => void;
  readonly className?: string;
  readonly type?: "button" | "submit" | "reset";
}

export function IconActionButton({
  iconName,
  iconSize = 16,
  onClick,
  className,
  type = "button",
}: IconActionButtonProps): JSX.Element {
  return (
    <button
      type={type}
      className={className ?? "text-content-secondary hover:text-content"}
      onClick={onClick}
    >
      <Icon name={iconName} size={iconSize} />
    </button>
  );
}
